export enum IBoosterBigDataType {
    ViewsLast3Days,
    HasIncreasedInterest
}
export enum IBoosterBigDataType {
    ViewsLast3Days,
    HasIncreasedInterest
}
